export const onRupiah = (number) =>
  new Intl.NumberFormat('id-ID', {
    style: 'decimal',
    currency: 'IDR'
  }).format(number)
